(async () => {
  const searchForm = document.getElementById('blog_search_form')
  const searchInput = document.getElementById('blog-search-input')
  const allFilterCheckboxes = Array.from(document.querySelectorAll('.filter-checkbox'))
  const noResults = document.getElementById('blog-no-results')
  const showMoreButton = document.getElementById('show_more')
  const clearSearchButton = document.getElementById('clear_search')
  const showSearchButton = document.getElementById('show_search')
  const itemsFound = document.getElementById('items_found')
  const activeFacetsContainer = document.querySelector('.active-facets')
  const articlesContainer = document.querySelector('.articles-wrapper')

  const toggleButton = document.getElementById('blog-search-filters-toggle')
  const overlay = document.getElementById('blog-search-filters-overlay')
  const closeButton = document.getElementById('blog-search-filters-close')
  const panel = overlay ? overlay.querySelector('.blog-search-filters-panel') : null
  const mobileSections = Array.from(document.querySelectorAll('.blog-search-filter-section'))
  const mobileButtonBaseLabel = 'Filter'
  const PANEL_TRANSITION_MS = 300
  const manuallyClosedSections = new Set()

  // filters passed through the URL
  const urlParams = new URLSearchParams(window.location.search)

  const filterState = {
    search: urlParams.get('search') || '',
    categories: (urlParams.get('category') || '').split(',').filter(Boolean),
    meal_types: (urlParams.get('mealtype') || '').split(',').filter(Boolean),
    products: (urlParams.get('product') || '').split(',').filter(Boolean),
    lifestyle_diets: (urlParams.get('diet') || '').split(',').filter(Boolean)
  }

  const ITEMS_PER_PAGE = 12
  const QUERY_PER_PAGE = 150
  let displayLimit = parseInt(urlParams.get('limit')) || 12

  /**
   * Returns a list of selected facets from checked checkboxes
   * @returns {{group: string, value: string, label: string}[]}
   */
  const getSelectedFacets = () => {
    const selectedFacets = []
    const seen = new Set()

    allFilterCheckboxes
      .filter((checkbox) => checkbox.checked)
      .forEach((checkbox) => {
        const label = document.querySelector(`label[for="${checkbox.id}"]`)
        const facet = {
          group: checkbox.dataset.filterGroup,
          groupSingle: checkbox.dataset.filterGroupSingle,
          value: checkbox.value,
          label: label?.dataset.filterLabel || checkbox.value
        }
        const key = `${facet.group}:${facet.value}`

        if (!seen.has(key)) {
          seen.add(key)
          selectedFacets.push(facet)
        }
      })

    return selectedFacets
  }

  /**
   * Renders selected facets into the active facets container
   */
  const renderActiveFacets = () => {
    if (!activeFacetsContainer) return

    const selectedFacets = getSelectedFacets()
    activeFacetsContainer.innerHTML = ''

    if (!selectedFacets.length && !searchInput.value) {
      activeFacetsContainer.hidden = true
      return
    }

    activeFacetsContainer.hidden = false

    selectedFacets.forEach((facet) => {
      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'active-facets__item'
      button.dataset.filterGroup = facet.group
      button.dataset.filterValue = facet.value
      button.setAttribute('aria-label', `Remove ${facet.label} filter`)
      button.innerHTML = `<span>${facet.groupSingle}: ${facet.label}</span><span aria-hidden="true">×</span>`

      button.addEventListener('click', () => {
        getCheckboxesByGroup(facet.group)
          .filter((checkbox) => checkbox.value === facet.value)
          .forEach((checkbox) => {
            checkbox.checked = false
          })

        syncStateFromUI()
        applyFilters()
      })

      activeFacetsContainer.appendChild(button)
    })

    if (searchInput.value) {
      const searchText = document.createElement('button')
      searchText.type      = 'button'
      searchText.className = 'active-facets__item'
      searchText.setAttribute('aria-label', `Remove search text filter`)
      searchText.innerHTML = `<span>Search: ${searchInput.value}</span><span aria-hidden="true">×</span>`
      searchText.addEventListener('click', () => {
        searchInput.value = ''
        searchInput.dispatchEvent(new Event('input', { bubbles: true }))
        syncStateFromUI()
        applyFilters()
      })

      activeFacetsContainer.appendChild(searchText)
    }
  }

  /**
   * Returns a list of checkboxes by group
   * @param group
   * @returns {HTMLInputElement[]}
   */
  const getCheckboxesByGroup = (group) => {
    return allFilterCheckboxes.filter((checkbox) => checkbox.dataset.filterGroup === group)
  }

  /**
   * Returns a list of checked values by group
   * @param group
   * @returns {string[]}
   */
  const getCheckedValuesByGroup = (group) => {
    return [...new Set(
      getCheckboxesByGroup(group)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.value)
    )]
  }

  /**
   * Sets the checked state of checkboxes by group
   * @param group
   * @param values
   */
  const setCheckedValuesByGroup = (group, values) => {
    getCheckboxesByGroup(group).forEach((checkbox) => {
      checkbox.checked = values.includes(checkbox.value)
    })
  }

  /**
   * Updates selected counts for each blog-search section heading
   */
  const updateMobileFilterCounts = () => {
    mobileSections.forEach((group) => {
      const checkedCount = group.querySelectorAll('input[type="checkbox"]:checked').length
      const count = group.querySelector('.blog-search-filter-section-title span')

      if (count) {
        //count.textContent = checkedCount > 0 ? `(${checkedCount} selected)` : ''
      }
    })
  }

  /**
   * Toggles a blog-search filter section
   * @param group
   * @param shouldOpen
   */
  //const setMobileSectionState = (group, shouldOpen) => {
  //  const button = group.querySelector('.blog-search-filter-toggle-button')
  //
  //  if (!button) return
  //
  //  group.classList.toggle('is-open', shouldOpen)
  //  button.setAttribute('aria-expanded', String(shouldOpen))
  //
  //  const icon = button.querySelector('svg')
  //  if (icon) {
  //    icon.classList.toggle('arrow-up', shouldOpen)
  //  }
  //}

  /**
   * Auto-opens a section if it has checked filters.
   * Does not auto-close an already open section.
   * @param group
   */
  //const syncMobileSectionState = (group) => {
  //  const checkedCheckbox = group.querySelector('input[type="checkbox"]:checked')
  //
  //  if (checkedCheckbox) {
  //    setMobileSectionState(group, true)
  //  }
  //}

  /**
   * Syncs all blog-search sections from current checked state
   */
  const syncAllMobileSections = () => {
    mobileSections.forEach((group) => {
      syncMobileSectionState(group)
    })
  }

  const hasSelectedFilters = () => {
    return allFilterCheckboxes.some((checkbox) => checkbox.checked)
  }

  /**
   * Opens the filter drawer
   */
  const openFilters = () => {
    if (!toggleButton || !overlay) return

    if (panel) {
      panel.classList.remove('is-closing')
    }

    overlay.classList.add('is-open')
    overlay.setAttribute('aria-hidden', 'false')
    toggleButton.setAttribute('aria-expanded', 'true')

    syncAllMobileSections()

    if (!hasSelectedFilters() && mobileSections.length > 0) {
      mobileSections.forEach((group, index) => {
        setMobileSectionState(group, index === 0)
      })
      setMobileSectionState(mobileSections[0], true)
    }

    if (window.innerWidth < 768) {
      document.body.style.overflow = 'hidden'
    }
  }

  /**
   * Closes the filter drawer
   */
  const closeFilters = () => {
    if (!toggleButton || !overlay) return

    if (panel) {
      panel.classList.add('is-closing')
    }

    overlay.classList.remove('is-open')
    overlay.setAttribute('aria-hidden', 'true')
    toggleButton.setAttribute('aria-expanded', 'false')
    document.body.style.overflow = ''

    if (panel) {
      window.setTimeout(() => {
        panel.classList.remove('is-closing')
      }, PANEL_TRANSITION_MS)
    }
  }

  /**
   * Updates the UI based on the current filter state
   */
  const syncUIFromState = () => {
    setCheckedValuesByGroup('categories', filterState.categories)
    setCheckedValuesByGroup('meal_types', filterState.meal_types)
    setCheckedValuesByGroup('products', filterState.products)
    setCheckedValuesByGroup('lifestyle_diets', filterState.lifestyle_diets)

    if (searchInput) {
      searchInput.value = filterState.search
      searchInput.classList.toggle('glow', Boolean(filterState.search))
    }

    updateMobileFilterCounts()
    syncAllMobileSections()
    renderActiveFacets()
  }

  /**
   * Updates the filter state based on the UI
   */
  const syncStateFromUI = () => {
    filterState.categories = getCheckedValuesByGroup('categories')
    filterState.meal_types = getCheckedValuesByGroup('meal_types')
    filterState.products = getCheckedValuesByGroup('products')
    filterState.lifestyle_diets = getCheckedValuesByGroup('lifestyle_diets')
  }

  /**
   * Initializes filters from URL state
   */
  const initializeFiltersFromURLState = () => {
    syncUIFromState()
    syncStateFromUI()
    updateAllCounts()
    filterArticles()
  }

  /**
   * Updates the URL with the current filter state
   */
  const updateURL = () => {
    const params = new URLSearchParams()

    if (filterState.search) params.set('search', filterState.search)
    if (filterState.categories.length) params.set('category', filterState.categories.join(','))
    if (filterState.meal_types.length) params.set('mealtype', filterState.meal_types.join(','))
    if (filterState.products.length) params.set('product', filterState.products.join(','))
    if (filterState.lifestyle_diets.length) params.set('diet', filterState.lifestyle_diets.join(','))
    if (displayLimit > ITEMS_PER_PAGE) params.set('limit', displayLimit)

    const path = window.location.pathname.startsWith('/')
      ? window.location.pathname
      : `/${window.location.pathname}`

    const newURL = params.toString()
      ? `${path}?${params.toString()}`
      : path

    window.history.pushState({}, '', newURL)
  }

  /**
   * Resets the pagination to the first page
   */
  const resetPagination = () => {
    displayLimit = ITEMS_PER_PAGE
  }

  /**
   * @param selectedValues
   * @param articleValues
   * @returns {boolean}
   */
  const matchesAny = (selectedValues, articleValues) => {
    if (selectedValues.length === 0) return true
    return selectedValues.some((value) => articleValues.includes(value))
  }

  /**
   * Checks if an article matches the search term
   * @param article
   * @returns {boolean}
   */
  const checkSearchMatch = (article) => {
    if (filterState.search === '') return true

    const titleEl = article.querySelector('.article-card__title, .card__heading, h3, h2')
    const title = titleEl ? titleEl.textContent.trim() : ''
    const contentEl = article.querySelector('.article-card__excerpt, .card__text, p')
    const content = contentEl ? contentEl.textContent.trim() : ''
    const authorEl = article.querySelector('.article-card__author')
    const author = authorEl ? authorEl.textContent.trim() : ''
    const tags = article.getAttribute('data-blog-tags') || ''

    const lowerSearchTerm = filterState.search.toLowerCase().trim()
    const searchableText = `${title} ${content} ${author} ${tags}`.toLowerCase()

    return lowerSearchTerm.split(' ').every(word => searchableText.includes(word))
  }

  /**
   * Calculates the number of articles matching each filter combination
   * @returns {{categories: {total: number, entries: {}, articles: {}}, meal_types: {total: number, entries: {}, articles: {}}, products: {total: number, entries: {}, articles: {}}, lifestyle_diets: {total: number, entries: {}, articles: {}}}}
   */
  const calculateCounts = () => {
    const counts = {
      categories: { total: 0, entries: {}, articles: {} },
      meal_types: { total: 0, entries: {}, articles: {} },
      products: { total: 0, entries: {}, articles: {} },
      lifestyle_diets: { total: 0, entries: {}, articles: {} }
    }

    document.querySelectorAll('.blog__post.main_blog_item').forEach((article) => {
      const matchesSearch = checkSearchMatch(article)

      const categories = (article.getAttribute('data-blog-categories') || '').split(',').filter(Boolean)
      const meal_types = (article.getAttribute('data-blog-meal-types') || '').split(',').filter(Boolean)
      const products = (article.getAttribute('data-blog-products') || '').split(',').map((entry) => entry.split('|')[0]).filter(Boolean)
      const lifestyle_diets = (article.getAttribute('data-blog-lifestyle-diets') || '').split(',').filter(Boolean)
      const id = article.getAttribute('data-blog-id')

      categories.forEach((category) => {
        const matchesOtherFilters = matchesSearch &&
          matchesAny(filterState.products, products) &&
          matchesAny(filterState.lifestyle_diets, lifestyle_diets) &&
          matchesAny(filterState.meal_types, meal_types)

        if (matchesOtherFilters) {
          counts.categories.entries[category] = (counts.categories.entries[category] || 0) + 1
          counts.categories.articles[id] = true
        }
      })

      meal_types.forEach((mealType) => {
        const matchesOtherFilters = matchesSearch &&
          matchesAny(filterState.categories, categories) &&
          matchesAny(filterState.products, products) &&
          matchesAny(filterState.lifestyle_diets, lifestyle_diets)

        if (matchesOtherFilters) {
          counts.meal_types.entries[mealType] = (counts.meal_types.entries[mealType] || 0) + 1
          counts.meal_types.articles[id] = true
        }
      })

      products.forEach((product) => {
        const matchesOtherFilters = matchesSearch &&
          matchesAny(filterState.categories, categories) &&
          matchesAny(filterState.meal_types, meal_types) &&
          matchesAny(filterState.lifestyle_diets, lifestyle_diets)

        if (matchesOtherFilters) {
          counts.products.entries[product] = (counts.products.entries[product] || 0) + 1
          counts.products.articles[id] = true
        }
      })

      lifestyle_diets.forEach((diet) => {
        const matchesOtherFilters = matchesSearch &&
          matchesAny(filterState.categories, categories) &&
          matchesAny(filterState.meal_types, meal_types) &&
          matchesAny(filterState.products, products)

        if (matchesOtherFilters) {
          counts.lifestyle_diets.entries[diet] = (counts.lifestyle_diets.entries[diet] || 0) + 1
          counts.lifestyle_diets.articles[id] = true
        }
      })
    })

    counts.categories.total = Object.keys(counts.categories.articles).length
    counts.meal_types.total = Object.keys(counts.meal_types.articles).length
    counts.products.total = Object.keys(counts.products.articles).length
    counts.lifestyle_diets.total = Object.keys(counts.lifestyle_diets.articles).length

    return counts
  }

  /**
   * Updates the counts next to each filter option
   * @param group
   * @param entries
   */
  const updateCheckboxCounts = (group, entries) => {
    const labels = document.querySelectorAll(`label[data-filter-group="${group}"]`)

    labels.forEach((label) => {
      const link = label.querySelector('a')
      const counts = label.querySelector('span')
      const value = label.dataset.filterValue
      const count = entries[value] || 0
      const checkboxId = label.getAttribute('for')
      const checkbox = checkboxId ? document.getElementById(checkboxId) : null
      const wrapper = label.closest('div')

      counts.textContent = `(${count})`

      if (checkbox) {
        checkbox.disabled = count === 0 && !checkbox.checked
      }

      if (wrapper) {
        wrapper.classList.toggle('filter-option--disabled', count === 0 && checkbox && !checkbox.checked)
      }
    })
  }

  /**
   * Updates the counts next to each filter option for all groups
   */
  const updateAllCounts = () => {
    const counts = calculateCounts()
    updateCheckboxCounts('categories', counts.categories.entries)
    updateCheckboxCounts('meal_types', counts.meal_types.entries)
    updateCheckboxCounts('products', counts.products.entries)
    updateCheckboxCounts('lifestyle_diets', counts.lifestyle_diets.entries)
    updateMobileFilterCounts()
  }

  /**
   * Finds articles that match the current filters
   * @param article
   * @returns {boolean}
   */
  const findMatches = (article) => {
    const titleEl = article.querySelector('.article-card__title, .card__heading, h3, h2')
    const title = titleEl ? titleEl.textContent.trim() : ''
    const contentEl = article.querySelector('.article-card__excerpt, .card__text, p')
    const content = contentEl ? contentEl.textContent.trim() : ''
    const authorEl = article.querySelector('.article-card__author')
    const author = authorEl ? authorEl.textContent.trim() : ''
    const tags = article.getAttribute('data-blog-tags') || ''

    const categories = (article.getAttribute('data-blog-categories') || '').split(',').filter(Boolean)
    const meal_types = (article.getAttribute('data-blog-meal-types') || '').split(',').filter(Boolean)
    const products = (article.getAttribute('data-blog-products') || '').split(',').map((entry) => entry.split('|')[0]).filter(Boolean)
    const lifestyle_diets = (article.getAttribute('data-blog-lifestyle-diets') || '').split(',').filter(Boolean)

    let searchMatch = null
    if (filterState.search !== '') {
      searchMatch = filterState.search
        .toLowerCase()
        .trim()
        .split(' ')
        .every((word) => `${title} ${content} ${author} ${tags}`.toLowerCase().includes(word))
    }

    return (searchMatch === true || searchMatch === null) &&
      matchesAny(filterState.categories, categories) &&
      matchesAny(filterState.meal_types, meal_types) &&
      matchesAny(filterState.products, products) &&
      matchesAny(filterState.lifestyle_diets, lifestyle_diets)
  }

  /**
   * Filters articles based on the current filter state
   */
  const filterArticles = () => {
    syncStateFromUI()

    let matchedCount = 0
    let displayedCount = 0

    document.querySelectorAll('.blog__post.main_blog_item').forEach((article) => {
      const matchesFilters = findMatches(article)

      if (matchesFilters) {
        matchedCount++
        if (displayedCount < displayLimit) {
          article.classList.remove('hidden')
          displayedCount++
        } else {
          article.classList.add('hidden')
        }
      } else {
        article.classList.add('hidden')
      }
    })

    if (noResults && showMoreButton) {
      if (matchedCount === 0) {
        noResults.classList.add('active')
        showMoreButton.style.display = 'none'
      } else {
        noResults.classList.remove('active')
        showMoreButton.style.display = matchedCount > displayedCount ? 'block' : 'none'
      }
    }

    updateShowSearchButtonText()
  }

  /**
   * Updates the counts next to each filter option for blog-search filters
   */
  const updateShowSearchButtonText = () => {
    if (!showSearchButton) return

    const matchedCount = getFoundItemCount()
    showSearchButton.textContent = `Show ${matchedCount} item${matchedCount === 1 ? '' : 's'}`
    itemsFound.textContent = `${matchedCount} blog${matchedCount === 1 ? '' : 's'}`
  }

  /**
   * Returns the number of articles that match the current filters
   * @returns {number}
   */
  const getFoundItemCount = () => {
    let matchedCount = 0

    document.querySelectorAll('.blog__post.main_blog_item').forEach((article) => {
      if (findMatches(article)) {
        matchedCount++
      }
    })

    return matchedCount
  }

  /**
   * Applies all filters and updates UI
   */
  const applyFilters = () => {
    resetPagination()
    syncUIFromState()
    updateURL()
    updateAllCounts()
    filterArticles()
    renderActiveFacets()
  }

  /**
   * Toggles a blog-search filter section
   * @param group
   * @param shouldOpen
   * @param options
   */
  const setMobileSectionState = (group, shouldOpen, options = {}) => {
    const button = group.querySelector('.blog-search-filter-toggle-button')

    if (!button) return

    const { rememberClose = false } = options

    group.classList.toggle('is-open', shouldOpen)
    button.setAttribute('aria-expanded', String(shouldOpen))

    if (shouldOpen) {
      manuallyClosedSections.delete(group)
    } else if (rememberClose) {
      manuallyClosedSections.add(group)
    }

    const icon = button.querySelector('svg')
    if (icon) {
      icon.classList.toggle('arrow-up', shouldOpen)
    }
  }

  /**
   * Auto-opens a section if it has checked filters.
   * Does not override sections the user has manually closed.
   * @param group
   */
  const syncMobileSectionState = (group) => {
    if (manuallyClosedSections.has(group)) return

    const checkedCheckbox = group.querySelector('input[type="checkbox"]:checked')

    if (checkedCheckbox) {
      setMobileSectionState(group, true)
    }
  }

  mobileSections.forEach((group) => {
    const sectionToggle = group.querySelector('.blog-search-filter-toggle')
    const checkboxes = group.querySelectorAll('input[type="checkbox"]')

    if (sectionToggle) {
      sectionToggle.addEventListener('click', (event) => {
        if (event.target.closest('input[type="checkbox"], label')) return

        const button = group.querySelector('.blog-search-filter-toggle-button')
        const isOpen = button && button.getAttribute('aria-expanded') === 'true'
        setMobileSectionState(group, !isOpen, { rememberClose: !isOpen ? false : true })
      })
    }

    syncMobileSectionState(group)

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        syncMobileSectionState(group)
        updateMobileFilterCounts()
      })
    })
  })

  if (toggleButton && overlay && closeButton) {
    toggleButton.addEventListener('click', openFilters)
    closeButton.addEventListener('click', closeFilters)

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        closeFilters()
      }
    })
  }

  if (searchForm) {
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault()
    })
  }

  if (searchInput) {
    searchInput.addEventListener('input', (event) => {
      filterState.search = event.target.value
      searchInput.classList.toggle('glow', Boolean(filterState.search))
      applyFilters()
    })

    searchInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
      }
    })
  }

  allFilterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const group = checkbox.dataset.filterGroup
      const value = checkbox.value
      const isChecked = checkbox.checked

      getCheckboxesByGroup(group)
        .filter((otherCheckbox) => otherCheckbox.value === value)
        .forEach((otherCheckbox) => {
          otherCheckbox.checked = isChecked
        })

      syncStateFromUI()
      updateMobileFilterCounts()
      applyFilters()
    })
  })

  if (showMoreButton) {
    showMoreButton.addEventListener('click', (event) => {
      event.preventDefault()
      displayLimit += ITEMS_PER_PAGE
      updateURL()
      filterArticles()
    })
  }

  if (clearSearchButton) {
    clearSearchButton.addEventListener('click', (event) => {
      event.preventDefault()

      filterState.search = ''
      filterState.categories = []
      filterState.meal_types = []
      filterState.products = []
      filterState.lifestyle_diets = []

      syncUIFromState()
      resetPagination()
      updateURL()
      updateAllCounts()
      filterArticles()
      renderActiveFacets()
      document.dispatchEvent(new CustomEvent('blog-filters-ui-updated'))
    })
  }

  if (showSearchButton) {
    showSearchButton.addEventListener('click', (event) => {
      event.preventDefault()
      closeFilters()
    })
  }

  document.querySelectorAll('.blog-search-filters-panel a').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()

      const label = link.closest('label')
      if (!label) return

      const checkboxId = label.getAttribute('for')
      const checkbox = checkboxId ? document.getElementById(checkboxId) : null
      if (!checkbox || checkbox.disabled) return

      checkbox.checked = !checkbox.checked
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  })

  document.addEventListener('blog-filters-ui-updated', () => {
    syncUIFromState()
    updateAllCounts()
    updateShowSearchButtonText()
    renderActiveFacets()
  })

  initializeFiltersFromURLState()

  // load all articles from shopify
  document.addEventListener('DOMContentLoaded', async () => {
    let page = 2
    do {
      const response = await fetch(`${window.location.pathname}?page=${page}&per_page=${QUERY_PER_PAGE}`)
      const html = await response.text()
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const articles = doc.querySelectorAll('.blog__post.main_blog_item')

      if (articles.length === 0) break

      articles.forEach((article) => {
        article.classList.add('hidden')
        if (articlesContainer) {
          articlesContainer.appendChild(article)
        }
      })

      syncStateFromUI()
      updateAllCounts()
      filterArticles()
      renderActiveFacets()

      await new Promise(resolve => setTimeout(resolve, 150))
    } while (page++ < 100)
  })
})()
